/**
 * Entity icons for the meta-agent's UI.
 *
 * The rest of the product already has a visual language for these — the
 * graduation cap is a skill, the database cylinder is a data bundle (see the
 * nav icons in components/layout/Sidebar.tsx, which is where these paths come
 * from). The AoA surfaces had drifted into their own set: a star for skills, a
 * folder for bundles, and — in the config modal — a folder for skills too, so
 * skills and bundles were indistinguishable.
 *
 * One definition each, used by every AoA surface, so a proposal card and the
 * page behind it show the user the same symbol for the same thing.
 */
import React from 'react';

interface IconProps {
  /** Square edge length in px. Cards use 20, list rows 22. */
  size?: number;
}

/** Skill — graduation cap. */
export const SkillIcon: React.FC<IconProps> = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 10l-10-5-10 5 10 5 10-5z" />
    <path d="M6 12v5c0 1.66 2.69 3 6 3s6-1.34 6-3v-5" />
    <path d="M22 10v6" />
  </svg>
);

/** Data bundle — database cylinder. */
export const BundleIcon: React.FC<IconProps> = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <ellipse cx="12" cy="5" rx="9" ry="3" />
    <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
  </svg>
);

/** Library folder — folder outline (matches the Library page's tree icons). */
export const LibraryFolderIcon: React.FC<IconProps> = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
  </svg>
);
